export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-icon/index.js